import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import AppWeather from './AppWeather.vue'
import AppWeatherList from './AppWeatherList.vue'

Vue.use(VueScrollTo)

new Vue({
  el: '#weather-wrap',
  data: {
    currentWeather: currentWeather,
    listWeather: listWeather
  },
  render: h => h(AppWeather),
  mounted: function () {
  }
});

new Vue({
  el: '#weather-wrap-list',
  data: {listWeather: listWeather},
  render: h => h(AppWeatherList),
  mounted: function () {
  }
});



// WEBPACK FOOTER //
// ./src/main.js